import { useMutation } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type ChangeShipmentModalityData } from '@/infra/services/checkout/cart/change-shipment-modality';

interface UseChangeShipmentModality {
  onError?: () => void;
  onSuccess?: () => void;
}

const useChangeShipmentModality = (
  props?: Readonly<UseChangeShipmentModality>
) => {
  const { onError, onSuccess } = props ?? {};

  const result = useMutation({
    mutationFn: (data: ChangeShipmentModalityData) =>
      Services.Checkout.Cart.changeShipmentModality(data),
    onError,
    onSuccess,
  });

  return result;
};

export default useChangeShipmentModality;
